import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex flex-column",
  "data-kt-landing": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row" })
], -1)
const _hoisted_2 = { class: "p-10" }
const _hoisted_3 = { class: "landingSubtitle pb-5" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "mr-2 pt-5 textoCentrado" }
const _hoisted_6 = { class: "mr-2 pt-5 textoCentrado mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.i18n("formularioInscripcion")), 1),
      _createElementVNode("div", {
        class: "textoJustificado landingInfoText",
        innerHTML: _ctx.$t('descripcionFormularioProfesionales')
      }, null, 8, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: "/formulario-profesionales",
          class: "btn btn-primary botonFormSecondary3",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.i18n("cumplimentarCuestionarioBtn")), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: "/formulario-actualizacion-profesionales",
          class: "btn btn-primary botonForm",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.i18n("actualizarProfesional.boton")), 1)
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}